// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "thiago-borrelli-68ed6.firebaseapp.com",
  "projectId": "thiago-borrelli-68ed6",
  "storageBucket": "thiago-borrelli-68ed6.appspot.com",
  "messagingSenderId": "496817836483",
  "appId": "1:496817836483:web:89a2442904eb7e7ddeed76",
  "measurementId": "G-73RH6DEZML",
  "apiKey": "AIzaSyDb6y6ChjxFORryndwVcflGJjSJ340Ot2o"
};
